import { getAppConfig } from "@/services/user/user";
import { makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";

interface AppConfigType {
  [key: string]: any;
}
class AppStore {
  // 配置信息
  config: AppConfigType = JSON.parse(localStorage.getItem("AppStore") ?? "{}")?.config || {};
  isOdm = +process.env.REACT_APP_AID !== 0;
  // 初始化
  constructor() {
    makeAutoObservable(this);
    // 持久化存储
    makePersistable(this, {
      name: "AppStore",
      properties: ["config"],
      storage: window.localStorage,
    });
  }
  // 是否在iframe中
  get isInFrame() {
    return window.self !== window.top;
  }

  // 获取配置信息
  async getConfig() {
    const data = await getAppConfig({ key: "crm_config" });
    this.config = data || {};
  }
}
const appStore = new AppStore();
export default appStore;
